/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./css.module.css";
import PropTypes from "prop-types";

const Select = (props) => {
  return (
    <div className={[classes.mainDiv, props.divClass].join(" ")}>
      {props.label ? (
        <label className={[classes.labelClass, props.labelClass].join(" ")}>
          {props.label}
        </label>
      ) : null}
      <select
        name={props.name}
        onChange={props.onChange}
        value={props.selected}
        className={[classes.selectClass, props.selectClass].join(" ")}
        disabled={props.disabled}
      >
        {props.default ? (
          <option value={""} className={[props.optionClass].join(" ")}>
            {props.default}
          </option>
        ) : null}
        {props.options.map((item, index) => (
          <option
            className={[props.optionClass].join(" ")}
            key={index}
            value={props.value ? props.value(item) : index}
          >
            {props.optionLabel ? props.optionLabel(item) : item}
          </option>
        ))}
      </select>
    </div>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  selected: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  default: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array.isRequired,
  value: PropTypes.func,
  optionLabel: PropTypes.func,

  // classes
  divClass: PropTypes.string,
  labelClass: PropTypes.string,
  selectClass: PropTypes.string,
  optionClass: PropTypes.string,
};

export default Select;
